import { createFileRoute } from "@tanstack/react-router";
import { Header } from "@/components/rawan/Header";
import { Footer } from "@/components/rawan/Footer";
import { EditableStaticPage } from "@/components/rawan/EditableStaticPage";

export const Route = createFileRoute("/about")({
  head: () => ({
    meta: [
      { title: "من نحن — Rawan UI" },
      { name: "description", content: "صفحة من نحن للتعريف بمشروع Rawan UI وأهدافه." },
    ],
  }),
  component: AboutPage,
});

function AboutPage() {
  return (
    <div className="min-h-dvh flex flex-col">
      <Header />
      <main className="flex-1 container mx-auto px-4 py-12 max-w-3xl">
        <EditableStaticPage
          pageKey="about"
          titleAr="من نحن"
          titleEn="About Us"
          defaultParagraphsAr={[
            "مرحباً بك في Rawan UI، المنصة الحديثة والمُطوّرة لعرض ومتابعة أحدث الأفلام والمسلسلات العربية والعالمية بجودة عالية وتجربة مستخدم سلسة وخالية من التعقيد.",
            "تم بناء هذا المشروع ليوفر واجهة مستخدم فائقة السرعة، تدعم الوضع الليلي والنهاري، وتتكيف مع جميع الشاشات والأجهزة، مع التركيز على سهولة الوصول والتصفح.",
            "نهدف دائماً لتطوير أدواتنا وتقديم أفضل تجربة للمشاهد العربي. شكراً لثقتكم ودعمكم المستمر!"
          ]}
          defaultParagraphsEn={[
            "Welcome to Rawan UI, a modern platform designed for discovering and tracking the latest movies and series with high quality and a seamless user experience.",
            "This project was built to provide a blazing fast user interface supporting dark and light modes, fully responsive across all devices.",
            "We are committed to continuously improving our tools to offer the best streaming browsing experience. Thank you for your support!"
          ]}
        />
      </main>
      <Footer />
    </div>
  );
}
